import { getApiUrl } from '../config';
import { buildSurveyAnswerPayloads, } from '../../../shared/utils/surveyAnswers';
export { buildQuestionKey } from '../../../shared/types/survey';
const API_BASE_URL = getApiUrl();
const submitSurvey = (payload) => fetch(`${API_BASE_URL}/v1/surveyResponses`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
});
const getErrorMessage = async (response) => {
    try {
        const data = await response.json();
        return data?.error?.message;
    }
    catch (parseError) {
        console.error('Survey submission error parsing response:', parseError);
        return undefined;
    }
};
const toLegacyAnswers = (answers) => answers.reduce((acc, { questionName, answerIndex }) => ({
    ...acc,
    [questionName]: answerIndex,
}), {});
export const submitSurveyResponses = async (params) => {
    const { sessionId, eventSlug, joinCode, questions, answers, surveyType, getQuestionKey, } = params;
    const payload = {
        sessionId,
        eventSlug,
        joinCode,
        answers: buildSurveyAnswerPayloads({
            questions,
            answers,
            getQuestionKey,
            toQuestionName: (questionKey) => `${surveyType}.${questionKey}`,
        }),
    };
    const response = await submitSurvey(payload);
    if (response.ok) {
        return;
    }
    const message = await getErrorMessage(response);
    if (message?.includes('answers must be an object')) {
        const retryResponse = await submitSurvey({
            ...payload,
            answers: toLegacyAnswers(payload.answers),
        });
        if (!retryResponse.ok) {
            const retryMessage = await getErrorMessage(retryResponse);
            throw new Error(retryMessage || 'Failed to submit survey');
        }
        return;
    }
    throw new Error(message || 'Failed to submit survey');
};
